const userSettingsReducer = (state = false, action) => {
  switch (action.type) {
    case `SHOW_USER_SETTINGS`: return true;
    case `HIDE_USER_SETTINGS`: return false;
    default: return state;
  }
};

export default userSettingsReducer;
